import React from 'react'
import './styles.scss'

interface Props {
  title: QuestionGroup
}

export const CategorySegment = ({ title }: Props) => {
  return (
    <div className='category-segment ui text container'>
      {/* <img
        className='cover-virus virus-1'
        src={require('./cover-virus-transparent-1.png')}
      />
      <img
        className='cover-virus virus-2'
        src={require('./cover-virus-transparent-2.png')}
      />
      <img
        className='cover-virus virus-3'
        src={require('./cover-virus-transparent-2.png')}
      />
      <img
        className='cover-virus virus-4'
        src={require('./cover-virus-transparent-2.png')}
      />
      <img
        className='cover-virus virus-5'
        src={require('./cover-virus-transparent-1.png')}
      /> */}
      <img src={require('./illus.png')} />
      <h4 className='ui header'>{title}</h4>
    </div>
  )
}
